import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AbstractControl, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { data } from 'highcharts';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-resetemail',
  templateUrl: './resetemail.html',
  styleUrls: ['./resetemail.css']
})
export class ResetemailComponent implements OnInit {
  public change=false;
  public ForgetPasswordForm: FormGroup;
  public submitted=false;


  constructor(private formBuilder: FormBuilder, private router: Router,private authService: AuthService) {
  }
  errtext="";
  ngOnInit(): void {
      this.ForgetPasswordForm = this.formBuilder.group({
        email:["", [Validators.required,Validators.email]],


            
             })

          };


          get formControl() {
              return this.ForgetPasswordForm.controls;
            }

            get email(){
              return this.ForgetPasswordForm.get("email")
            }

ChangePassword(){
 
localStorage.setItem('tempemail',this.ForgetPasswordForm.get("email").value)
  this.authService.resetpwdEmail(this.ForgetPasswordForm.get("email").value)
  .subscribe(data => {

   
    
    this.change=true
    this.errtext = 'Veuillez vérifier votre boite mail  '
 


   
  }, 
  
  error => {

   

    console.log(error, 'error')
    if (error.status == 404) {
      this.errtext = 'utilisateur inexistant ! '
      console.log('not found ')
      this.change=false
    }
 

  }
          
     
  
)  }

}
